module.exports = __webpack_public_path__ + "img/new_point0.907f6187.png";